<script lang="ts">
    import {Link} from 'svelte-routing'
    import {api} from 'src/services/api/reallis'
    import {getStakingBalance} from 'src/components/cabinet/#services/staking'
    import accountIcon from 'src/components/cabinet/#assets/account-icon.svg'
    import inventoryIcon from 'src/components/cabinet/#assets/inventory-icon.svg'
    import spinIcon from 'src/components/cabinet/#assets/spin-icon.svg'
    import stakingIcon from 'src/components/cabinet/#assets/staking-icon.svg'
    import swapIcon from 'src/components/cabinet/#assets/swap-icon.svg'
    import membershipsIcon from 'src/components/cabinet/#assets/memberships-icon.svg'
    import referralsIcon from 'src/components/cabinet/#assets/referrals-icon.svg'
    import activityIcon from 'src/components/cabinet/#assets/activity-icon.svg'
    import settingsIcon from 'src/components/cabinet/#assets/settings-icon.svg'
    import helpIcon from 'src/components/cabinet/#assets/help-icon.svg'
    import logoutIcon from 'src/components/cabinet/#assets/logout-icon.svg'

    let url = window.location.pathname

    function logOut() {
        api.ws.ws1.auth.logout()
    }
</script>

<div class="leftside-menu">
    <div class="h-100 overflow-auto">
        <ul class="side-nav top">
            <li class="side-nav-item {url === '/account' ? 'menuitem-active' : ''}">
                <Link to="account" class="side-nav-link">
                    <div class="icon"><img src="{accountIcon}" alt=""></div>
                    <span>Account</span>
                </Link>
            </li>
            <li class="side-nav-item {url.includes('/inventory') ? 'menuitem-active' : ''}">
                <Link to="inventory" class="side-nav-link">
                    <div class="icon"><img src="{inventoryIcon}" alt=""></div>
                    <span>Inventory</span>
                </Link>
            </li>
            <!--
            <li class="side-nav-item {url === '/spin' ? 'menuitem-active' : ''}">
                <Link to="spin" class="side-nav-link">
                    <div class="icon"><img src="{spinIcon}" alt=""></div>
                    <span>Spin</span>
                </Link>
            </li>
            -->
            {#if $getStakingBalance.hasValue && $getStakingBalance.value?.isUserParticipate}
<!--            <li class="side-nav-item {url === '/staking' ? 'menuitem-active' : ''}">-->
<!--                <Link to="staking" class="side-nav-link">-->
<!--                    <div class="icon"><img src="{stakingIcon}" alt=""></div>-->
<!--                    <span>Staking</span>-->
<!--                </Link>-->
<!--            </li>-->
            {/if}
            <li class="side-nav-item {url === '/swap' ? 'menuitem-active' : ''}">
                <Link to="swap" class="side-nav-link">
                    <div class="icon"><img src="{swapIcon}" alt=""></div>
                    <span>Swap</span>
                </Link>
            </li>
            <li class="side-nav-item {url === '/memberships' ? 'menuitem-active' : ''}">
                <Link to="memberships" class="side-nav-link">
                    <div class="icon"><img src="{membershipsIcon}" alt=""></div>
                    <span>Memberships</span>
                </Link>
            </li>
            <li class="side-nav-item {url === '/referrals' ? 'menuitem-active' : ''}">
                <Link to="referrals" class="side-nav-link">
                    <div class="icon"><img src="{referralsIcon}" alt=""></div>
                    <span>Referrals</span>
                </Link>
            </li>
            <li class="side-nav-item {url === '/activity' ? 'menuitem-active' : ''}">
                <Link to="activity" class="side-nav-link">
                    <div class="icon"><img src="{activityIcon}" alt=""></div>
                    <span>Activity</span>
                </Link>
            </li>
            <li class="side-nav-item {url.includes('/settings') ? 'menuitem-active' : ''}">
                <Link to="/settings" class="side-nav-link">
                    <div class="icon"><img src="{settingsIcon}" alt=""></div>
                    <span>Settings</span>
                </Link>
            </li>
        </ul>
        <ul class="side-nav bottom">
            <li class="side-nav-item">
                <Link to="support" class="side-nav-link">
                    <img src="{helpIcon}" alt="">
                    <span>Help Center</span>
                </Link>
            </li>
            <li class="side-nav-item logout-item" debug-id="logout">
                <div on:click={logOut} class="side-nav-link">
                    <img src="{logoutIcon}" alt="">
                    <span>Log out</span>
                </div>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>

<style>
    @import "../../../../styles/global/scrollbar.pcss";

    .overflow-auto {
        @include scrollbar;
        @include scroll-smooth;
    }

    .leftside-menu {
        top: 90px;
        min-width: 300px;
        background: #24214b;
        border-right: 2px solid #353064;
        height: calc(100vh - 90px);
        position: fixed;
        left: 0;
    }

    .side-nav-item :global(.side-nav-icon) {
        display: inline-block;
        line-height: 1.0625rem;
        margin: 0 10px 0 0;
        font-size: 1.1rem;
        vertical-align: middle;
        width: 20px;
    }

    .menu-arrow :global(svg) {
        font-size: 12px;
    }

    .menuitem-active .menu-arrow :global(svg) {
        transform: rotate(90deg);
    }

    ul {
        list-style-type: none;
        padding: 0;
        margin: 0;
    }

    .side-nav-second-level li :global(a) {
        padding: 8px 30px 8px 65px;
        color: #8391a2;
        display: block;
        position: relative;
        transition: all .25s;
        font-size: .89rem;
    }

    .side-nav-item.logout-item .side-nav-link {
        cursor: pointer;
    }

    .side-nav-second-level li :global(a:hover) {
        color: #bccee4;
    }

    .side-nav-second-level li :global(a.active) {
        color: white !important;
    }

    .leftside-menu :global(.logo) {
        display: block;
        line-height: 70px;
        width: 260px;
        position: fixed;
        top: 0;
    }

    .leftside-menu :global(.logo img) {
        width: 100px;
        margin: 12px 0 0 30px;
        display: block;
    }

    .side-nav {
        padding-left: 0;
        list-style-type: none;
    }

    .side-nav :global(li) {
        margin: 16px 0;
    }

    .icon {
        background: #534fa2;
        box-shadow: 0 -1px 1px 0 rgba(1, 7, 10, 0.3) inset;
        filter: drop-shadow(0px 1px 2px rgba(1, 7, 10, 0.30));
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-right: 10px;
        transition: .2s;
    }

    .icon img {
        filter: invert(0.8) brightness(1.4) grayscale(0.9);
        transition: .2s;
    }

    .side-nav.bottom {
        border-top: 2px solid #312d61;
        margin: 0 30px 30px;
        padding-top: 20px;
    }

    .side-nav.bottom :global(li) {
        margin: 10px 0;
    }

    .side-nav :global(.side-nav-link) {
        display: flex;
        align-items: center;
        padding: 8px;
        font-size: 16px;
        color: #9592CD;
        background: #343168;
        margin: 0 30px;
        position: relative;
        text-decoration: none;
        list-style: none;
        text-shadow: 0 1px 2px rgba(1, 7, 10, 0.3);
        font-weight: 600;
        line-height: 16px;
        border-radius: 50px;
        box-shadow: 0 1px 2px 0 rgba(1, 7, 10, 0.4) inset, 0 -1px 2px 0 rgba(1, 7, 10, 0.4) inset;
        transition: all .2s;
    }

    .side-nav :global(.side-nav-item:not(.menuitem-active) .side-nav-link:hover) {
        background: #494591;
        box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.3) inset, 0 -1px 1px 0 rgba(0, 0, 0, 0.4) inset;
    }

    .side-nav.bottom :global(.side-nav-link) {
        margin: 0;
        padding: 6px 20px 6px 10px;
        background: #2C2A54;
        box-shadow: none;
        color: white;
        font-size: 14px;
        font-weight: 500;
        width: auto;
        display: table;
    }

    .side-nav.bottom :global(.side-nav-link img) {
        margin-right: 5px;
    }

    .side-nav :global(.side-nav-link span) {
        vertical-align: middle;
    }

    .side-nav :global(.menu-arrow) {
        transition: transform .15s;
        position: absolute;
        right: 30px;
        display: inline-block;
        text-rendering: auto;
        line-height: 1.5rem;
        font-size: 1.1rem;
        -webkit-transform: translate(0,0);
        transform: translate(0,0);
    }

    .side-nav :global(.menu-arrow i) {
        font-size: 12px;
    }

    .side-nav :global(.collapse:not(.show)) {
        display: none;
    }

    .side-nav :global(.menuitem-active>a) {
        background: #7262FF;
        color: white;
        box-shadow: 0 1px 1px 0 rgba(255, 255, 255, 0.3) inset, 0 -1px 1px 0 rgba(0, 0, 0, 0.4) inset;
    }

    .side-nav :global(.side-nav-link:hover .icon) {
        background: #343168;
        box-shadow: 0 -1px 1px 0 rgba(1, 7, 10, 0.3) inset;
    }

    .side-nav :global(.menuitem-active>a .icon),
    .side-nav :global(.menuitem-active>a:hover .icon) {
        background: white;
    }

    .side-nav :global(.menuitem-active>a .icon img),
    .side-nav :global(.menuitem-active>a:hover .icon img) {
        filter: none;
    }

    .side-nav.bottom :global(.side-nav-item .side-nav-link:hover) {
        background: #343168;
        box-shadow: none;
        color: white;
    }

    .side-nav.top {
        min-height: calc(100vh - 286px);
        margin: 30px 0;
    }

    @media(max-width: 992px) {
        .leftside-menu {
            display: none;
        }
    }
</style>
